import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {navigateBack} from '../../router/actions';

export const fetchWarehouseDenialCausesList = () => apiActionCreator({
  'endpoint': '/warehouseDenialCauses',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WAREHOUSE_DENIAL_CAUSES_LIST,
    ActionTypes.FETCHED_WAREHOUSE_DENIAL_CAUSES_LIST,
    [
      ActionTypes.FETCHED_WAREHOUSE_DENIAL_CAUSES_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchWarehouseDenialCause = (code) => apiActionCreator({
  'endpoint': `/warehouseDenialCauses/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WAREHOUSE_DENIAL_CAUSE,
    ActionTypes.FETCHED_WAREHOUSE_DENIAL_CAUSE,
    [
      ActionTypes.FETCHED_WAREHOUSE_DENIAL_CAUSE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const addWarehouseDenialCause = (data) => apiActionCreator({
  'endpoint': '/warehouseDenialCauses',
  'authenticated': true,
  'types': [
    ActionTypes.ADDING_WAREHOUSE_DENIAL_CAUSE,
    [
      ActionTypes.ADDED_WAREHOUSE_DENIAL_CAUSE,
      navigateBack(),
      MessageActions.addMessageBoxInfo('Causa de warehouse denied añadida satisfactoriamente'),
    ],
    [
      ActionTypes.ADDED_WAREHOUSE_DENIAL_CAUSE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const editWarehouseDenialCause = (code, data) =>
  apiActionCreator({
    'endpoint': `/warehouseDenialCauses/${code}`,
    'authenticated': true,
    'types': [
      ActionTypes.SAVING_WAREHOUSE_DENIAL_CAUSE,
      [
        ActionTypes.SAVED_WAREHOUSE_DENIAL_CAUSE,
        navigateBack(),
        MessageActions.addMessageBoxInfo(
          'Causa de warehouse denied actualizada satisfactoriamente'
        ),
      ],
      [
        ActionTypes.SAVED_WAREHOUSE_DENIAL_CAUSE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });

export const filterWarehouseDenialCauses = (value) => ({
  'type': ActionTypes.FILTER_WAREHOUSE_DENIAL_CAUSES,
  'payload': value,
});

export const changeWarehouseDenialCausesTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_WAREHOUSE_DENIAL_CAUSES_TEXT_FILTER,
  'payload': value,
});
